export default __webpack_public_path__ + "static/media/wTop_2_p3.0b628854.jpeg";